import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useGetData } from "..";
import { ENDPOINTS } from "../../constants/endpoints";
import { getCompanyProfile } from "../../mock/services";

function useCompanyLogic() {
  const { company } = useParams();
  const url = `${ENDPOINTS.GET.SERVICES}${company}`;
  const [data, setData] = useState();
  /*   const { data } = useGetData(url, true); */

  console.log(company,data);
  
  useEffect(() => {
    setData(getCompanyProfile(company));
  }, [company]);

  return { data };
}

export default useCompanyLogic;
